export type ParticipantsApprovalBand = { type: 'ro' | 'cod_funcao'; values: string };

/**
 * Faixas de autorização da quantidade de participantes de uma Realização Destaque.
 * Espelha a régua da trigger backend `EdRRE14`. Retorna o `type`/`values` do nível que pode
 * autorizar a faixa (níveis superiores também constam em `values`), ou `null` quando a quantidade
 * é de até 20 participantes (liberada automaticamente, sem necessidade de aprovação).
 */
export function getParticipantsApprovalBand(total: number): ParticipantsApprovalBand | null {
  if (total >= 21 && total <= 30) {
    // Autorização a partir do Nível 1 (RO 3GUE, 2GUT, 2GCA, 2GUA)
    return { type: 'ro', values: '3GUE,2GUT,2GCA,2GUA,2GUE,1GUT,1GUA,1GCA,3003,4005,4007,3002' };
  }

  if (total >= 31 && total <= 50) {
    // Autorização a partir do Nível 2 (RO 2GUE, 1GUT, 1GUA, 1GCA)
    return { type: 'ro', values: '2GUE,1GUT,1GUA,1GCA,3003,4005,4007,3002' };
  }

  if (total >= 51 && total <= 100) {
    // Autorização a partir do Nível 3 (Diretor ou Gerente Geral UE)
    return { type: 'cod_funcao', values: '3003,4005,4007,3002' };
  }

  if (total > 100) {
    // Acima de 100: autorização exclusiva do Vice-Presidente
    return { type: 'cod_funcao', values: '3002' };
  }

  return null;
}
